import ProjectCreateV2 from '@containers/project/ProjectCreateV2';

const ProjectCreatePageV2 = () => {
  return <ProjectCreateV2 />;
};

export default ProjectCreatePageV2;
